/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmergencyRequest
 */
export interface CreateEmergencyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyRequest
     */
    incident: string;
    /**
     * 
     * @type {number}
     * @memberof CreateEmergencyRequest
     */
    degrees_bearing?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmergencyRequest
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmergencyRequest
     */
    longitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmergencyRequest
     */
    meters_per_second_speed?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEmergencyRequest
     */
    trigger_source?: string | null;
}

/**
 * Check if a given object implements the CreateEmergencyRequest interface.
 */
export function instanceOfCreateEmergencyRequest(value: object): value is CreateEmergencyRequest {
    if (!('incident' in value) || value['incident'] === undefined) return false;
    return true;
}

export function CreateEmergencyRequestFromJSON(json: any): CreateEmergencyRequest {
    return CreateEmergencyRequestFromJSONTyped(json, false);
}

export function CreateEmergencyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmergencyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'incident': json['incident'],
        'degrees_bearing': json['degrees_bearing'] == null ? undefined : json['degrees_bearing'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'meters_per_second_speed': json['meters_per_second_speed'] == null ? undefined : json['meters_per_second_speed'],
        'trigger_source': json['trigger_source'] == null ? undefined : json['trigger_source'],
    };
}

export function CreateEmergencyRequestToJSON(json: any): CreateEmergencyRequest {
    return CreateEmergencyRequestToJSONTyped(json, false);
}

export function CreateEmergencyRequestToJSONTyped(value?: CreateEmergencyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'incident': value['incident'],
        'degrees_bearing': value['degrees_bearing'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'meters_per_second_speed': value['meters_per_second_speed'],
        'trigger_source': value['trigger_source'],
    };
}

